export { default as LoginApi } from "./login";
export { default as StaffApi } from "./staff";
export { default as ClientesApi } from "./clientes";
export { default as RolesApi } from "./roles";
export { default as ComparecientesApi } from "./comparecientes";
export { default as RecuperarPassApi } from "./recuperarpass";
export { default as VerificarCuentaApi } from "./verificarCuenta";
export { default as LayoutsApi } from "./layouts";
export { default as FuncionesApi } from "./funciones";
export { default as CatNacionalidadesApi } from "./cat_nacionalidades";
export { default as CatObjetosSocialesApi } from "./cat_objetos_sociales";
export { default as ConstitucionSociedadesApi } from "./constitucion_sociedades";
export { default as CatFacultadesApi } from "./cat_facultades";
export { default as CatEntidadesFederativasApi } from "./cat_entidades_federativas";
export { default as MunicipiosApi } from "./municipios";
export { default as CorreduriasApi } from "./corredurias";
export { default as CatGastosApi } from "./cat_gastos";
export { default as CatFormulariosConstitucionSociedadesApi } from "./cat_formularios_x_constitucion_sociedades";
export { default as CambiosConstitutivaApi } from "./cambios_constitutiva";
export { default as EstatusApi } from "./estatus";
export { default as NotificacionesApi } from "./notificaciones";
export { default as DomiciliosApi } from "./domicilios";
export { default as NotificadosApi } from "./notificados";
export { default as CotejosApi } from "./cotejos";
export { default as CatDocumentosApi } from "./cat_documentos";
export { default as CotizacionesApi } from "./cotizaciones";
export { default as SolicitantesApi } from "./solicitantes";
export { default as DocumentosApi } from "./documentos";
export { default as DocumentosXServiciosApi } from "./documentosxservicios";
export { default as RatificacionesApi } from "./ratificaciones";
export { default as RatificantesApi } from "./ratificantes";
export { default as FormalizacionActasApi } from "./formalizacion_actas";
export { default as CatFormulariosFormalizacionesApi } from "./cat_formularios_formalizaciones";
export { default as CuponesApi } from "./cupones";
export { default as FacturasApi } from "./facturas";
export { default as RegionsApi } from "./regions";
export { default as MetaInfoApi } from "./meta_info";
export { default as ClausulasConfirmacionApi } from "./clausulas_confirmacion";
export { default as ClausulasConfirmacionProcesosApi } from "./clausulas_confirmacion_procesos";
export { default as FadProcesosApi } from "./fad_procesos";
export { default as CitasApi } from "./citas";
export { default as NotasClientesApi } from "./notas_clientes";
export { default as NotasProcesosApi } from "./notas_procesos";
export { default as BeneficiariosControladoresApi } from "./beneficiarios_controladores";
export { default as AccionistasApi } from "./accionistas";
export { default as ValidacionesDocumentosApi } from "./validaciones_documentos.js";
